var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCt6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 67,
    rx: 4,
    fill: "#E8F5FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_170_6962)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.0022 39.5421H18.9978C18.4467 39.5421 18 39.0953 18 38.5443V18.1384C18 17.5873 18.4467 17.1406 18.9978 17.1406H49.0022C49.5533 17.1406 49.9999 17.5874 49.9999 18.1384V38.5443C50 39.0953 49.5533 39.5421 49.0022 39.5421Z",
    fill: "url(#paint0_linear_170_6962)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5018 39.0367H19.5052C18.9759 39.0367 18.5469 38.6076 18.5469 38.0784V18.6048C18.5469 18.0755 18.9759 17.6465 19.5052 17.6465H48.5018C49.031 17.6465 49.4601 18.0755 49.4601 18.6048V38.0784C49.4601 38.6076 49.0311 39.0367 48.5018 39.0367Z",
    fill: "url(#paint1_linear_170_6962)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6545 38.0647H20.3491C19.906 38.0647 19.5469 37.7056 19.5469 37.2625V19.4233C19.5469 18.9802 19.906 18.6211 20.3491 18.6211H47.6545C48.0975 18.6211 48.4567 18.9802 48.4567 19.4233V37.2625C48.4567 37.7056 48.0976 38.0647 47.6545 38.0647Z",
    fill: "url(#paint2_linear_170_6962)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1429 18.6211H20.3491C19.906 18.6211 19.5469 18.9802 19.5469 19.4233V37.2625C19.5469 37.7056 19.906 38.0647 20.3491 38.0647H22.1429V18.6211Z",
    fill: "url(#paint3_linear_170_6962)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6545 18.6211H20.3491C19.906 18.6211 19.5469 18.9802 19.5469 19.4233V20.8762H48.4568V19.4233C48.4567 18.9802 48.0976 18.6211 47.6545 18.6211Z",
    fill: "url(#paint4_linear_170_6962)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2879 38.0635H47.5933C48.0364 38.0635 48.3955 37.7044 48.3955 37.2614V19.4221C48.3955 19.2066 48.3101 19.0113 48.1718 18.8672L19.6016 37.6752C19.742 37.9076 19.9964 38.0635 20.2879 38.0635Z",
    fill: "url(#paint5_linear_170_6962)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.875 25.1738V39.5439H49.0001C49.5512 39.5439 49.9979 39.0972 49.9979 38.5461V35.2967L39.875 25.1738Z",
    fill: "url(#paint6_linear_170_6962)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1795 36.424H21.8229C21.4418 36.424 21.1328 36.115 21.1328 35.7338V20.9499C21.1328 20.5687 21.4418 20.2598 21.8229 20.2598H46.1794C46.5606 20.2598 46.8695 20.5687 46.8695 20.9499V35.7338C46.8696 36.115 46.5606 36.424 46.1795 36.424Z",
    fill: "url(#paint7_linear_170_6962)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.875 25.1738V36.4253H46.1761C46.5573 36.4253 46.8663 36.1163 46.8663 35.7351V32.1651L39.875 25.1738Z",
    fill: "url(#paint8_linear_170_6962)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.001 41.6699C39.1231 41.6699 43.2754 37.5176 43.2754 32.3955C43.2754 27.2734 39.1231 23.1211 34.001 23.1211C28.8789 23.1211 24.7266 27.2734 24.7266 32.3955C24.7266 37.5176 28.8789 41.6699 34.001 41.6699Z",
    fill: "url(#paint9_linear_170_6962)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9963 41.0726C38.7879 41.0726 42.6722 37.1883 42.6722 32.3967C42.6722 27.6051 38.7879 23.7207 33.9963 23.7207C29.2047 23.7207 25.3203 27.6051 25.3203 32.3967C25.3203 37.1883 29.2047 41.0726 33.9963 41.0726Z",
    fill: "url(#paint10_linear_170_6962)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1481 24.0996C38.7736 25.348 39.1263 26.7569 39.1263 28.2483C39.1263 33.3705 34.974 37.5227 29.8518 37.5227C28.3604 37.5227 26.9515 37.1702 25.7031 36.5446C27.2259 39.5837 30.3687 41.6702 33.9994 41.6702C39.1215 41.6702 43.2738 37.518 43.2738 32.3958C43.2738 28.7652 41.1872 25.6224 38.1481 24.0996Z",
    fill: "url(#paint11_linear_170_6962)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0026 30.4328C37.1107 30.4328 39.6302 28.9683 39.6302 27.1617C39.6302 25.3551 37.1107 23.8906 34.0026 23.8906C30.8946 23.8906 28.375 25.3551 28.375 27.1617C28.375 28.9683 30.8946 30.4328 34.0026 30.4328Z",
    fill: "url(#paint12_linear_170_6962)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.535 26.9878C40.1595 25.841 38.3983 25.1891 36.5612 25.1891C36.5536 25.1891 36.5459 25.1891 36.5384 25.1891L36.5039 25.1892C35.4007 25.1892 34.3156 25.0355 33.2686 24.7321C34.094 24.145 34.9903 23.6729 35.9392 23.3259C35.4853 23.2294 35.0193 23.1661 34.5436 23.1387C33.8364 23.4843 33.1634 23.8993 32.5326 24.3796C32.5001 24.4043 32.4686 24.4303 32.4363 24.4554C31.8717 24.2444 31.3226 23.9886 30.7961 23.6913C30.5157 23.7946 30.2417 23.9109 29.9747 24.0398C30.5579 24.4042 31.1712 24.7194 31.8053 24.9809C31.2537 25.4726 30.7468 26.0131 30.2937 26.5974C30.2806 26.6142 30.2679 26.6314 30.2549 26.6483C29.2947 26.3376 28.3028 26.1167 27.2962 25.9893C27.0945 26.2003 26.9029 26.4207 26.7217 26.65C27.7724 26.7497 28.8094 26.9557 29.8123 27.2635C29.3402 27.9648 28.944 28.7116 28.6297 29.4939C27.6956 29.3097 26.7303 29.5015 25.9244 30.0431C25.4526 30.3601 25.0707 30.7727 24.7974 31.2478C24.7508 31.6244 24.7266 32.0078 24.7266 32.3969C24.7266 33.0879 24.8027 33.761 24.9461 34.4089C24.9606 34.1295 24.9933 33.5381 25.0427 32.8519C25.1076 31.951 25.5752 31.1449 26.3259 30.6405C26.9385 30.2287 27.666 30.0698 28.3778 30.1807C27.9682 31.4084 27.7602 32.6914 27.7602 34.0016C27.7602 36.3659 28.4585 38.6788 29.7466 40.6397C30.1612 40.8541 30.5939 41.0383 31.0419 41.189C29.3897 39.1672 28.48 36.618 28.48 34.0015C28.48 32.7561 28.6798 31.5373 29.073 30.3719C31.4551 31.2305 33.1363 33.3947 33.3735 35.9308C33.4472 36.7195 33.5424 37.2862 33.6566 37.6151C34.1571 39.0579 34.9878 40.366 36.0767 41.4378C36.3517 41.375 36.6218 41.2994 36.8869 41.2128C35.7258 40.1689 34.8465 38.8492 34.3367 37.3792C34.2442 37.1126 34.1566 36.5744 34.0902 35.8638C33.8273 33.052 31.9645 30.652 29.3243 29.6973C29.6405 28.924 30.042 28.1881 30.5225 27.5006C35.6163 29.3372 39.4177 33.7172 40.4945 39.0178C40.703 38.8133 40.9019 38.599 41.0904 38.3757C39.8491 33.1255 36.0394 28.8041 30.974 26.8995C31.4511 26.3038 31.987 25.7573 32.5735 25.2687C33.837 25.6935 35.1579 25.909 36.5039 25.909L36.541 25.9089H36.5617C38.801 25.9089 40.9164 26.9754 42.2237 28.7645L42.7484 29.4827L42.7965 29.4476C42.4989 28.5602 42.0708 27.7327 41.535 26.9878Z",
    fill: "#555A66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5753 25.2685C33.8387 25.6933 35.1597 25.9088 36.5057 25.9088L36.5427 25.9088H36.5635C38.3556 25.9088 40.0679 26.5924 41.3506 27.7823C40.8946 27.0577 40.3349 26.4053 39.6916 25.8461C38.7189 25.419 37.6544 25.1889 36.5632 25.1889C36.5556 25.1889 36.5479 25.1889 36.5403 25.1889L36.5058 25.189C35.4026 25.189 34.3175 25.0353 33.2706 24.7319C33.7875 24.3642 34.3322 24.0417 34.9002 23.7667C34.6053 23.7364 34.3059 23.7207 34.0029 23.7207C33.8222 23.7207 33.643 23.7269 33.465 23.7378C33.146 23.9367 32.8353 24.1503 32.5345 24.3793C32.5019 24.4041 32.4704 24.43 32.4382 24.4551C32.1343 24.3416 31.8351 24.2146 31.5413 24.0755C31.223 24.1695 30.9122 24.2809 30.6103 24.4093C30.9991 24.6211 31.3988 24.8122 31.8072 24.9806C31.2557 25.4723 30.7487 26.0128 30.2956 26.5971C30.2825 26.6139 30.2698 26.6311 30.2569 26.648C29.5319 26.4134 28.7889 26.2302 28.035 26.0996C27.8229 26.3007 27.6209 26.5123 27.43 26.7337C28.2388 26.8479 29.0369 27.0245 29.8142 27.2632C29.3421 27.9645 28.9459 28.7113 28.6316 29.4935C27.6975 29.3093 26.7321 29.5011 25.9262 30.0427C25.8051 30.1241 25.6902 30.2119 25.5813 30.3054C25.4663 30.7699 25.3883 31.249 25.3516 31.7398C25.5734 31.3024 25.9059 30.9237 26.3278 30.6402C26.9404 30.2284 27.6679 30.0694 28.3796 30.1804C27.97 31.408 27.7621 32.691 27.7621 34.0012C27.7621 35.9487 28.2363 37.8609 29.1231 39.5707C29.518 39.8398 29.9362 40.0769 30.3741 40.2788C29.1478 38.4273 28.4819 36.239 28.4819 34.0012C28.4819 32.7558 28.6816 31.537 29.0749 30.3716C31.457 31.2302 33.1382 33.3944 33.3754 35.9305C33.4491 36.7192 33.5443 37.2859 33.6585 37.6148C34.082 38.8357 34.7428 39.9596 35.5957 40.926C35.8681 40.8755 36.1362 40.8125 36.399 40.7371C35.4794 39.7791 34.7739 38.6341 34.3386 37.3789C34.2461 37.1122 34.1585 36.574 34.0921 35.8635C33.8292 33.0517 31.9663 30.6517 29.3262 29.6969C29.6424 28.9237 30.0438 28.1877 30.5244 27.5002C35.394 29.256 39.0821 33.3364 40.3382 38.3232C40.5378 38.11 40.7266 37.8868 40.904 37.6543C39.4965 32.7313 35.8074 28.7157 30.9759 26.8991C31.4528 26.3036 31.9888 25.7571 32.5753 25.2685Z",
    fill: "url(#paint13_linear_170_6962)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5607 25.1894C36.5531 25.1894 36.5454 25.1894 36.5379 25.1894L36.5034 25.1895C35.4002 25.1895 34.3151 25.0358 33.2681 24.7324C33.6983 24.4265 34.1478 24.1521 34.6139 23.91C34.4124 23.8973 34.2078 23.8906 34.0005 23.8906C33.7187 23.8906 33.442 23.9028 33.1714 23.926C32.954 24.0703 32.7405 24.2212 32.532 24.3799C32.4995 24.4046 32.468 24.4306 32.4357 24.4557C32.1992 24.3673 31.9656 24.2705 31.7351 24.1667C31.389 24.2552 31.0612 24.3633 30.7558 24.4888C31.0979 24.6692 31.4479 24.834 31.8048 24.9812C31.2532 25.4729 30.7463 26.0135 30.2932 26.5978C30.2801 26.6146 30.2674 26.6317 30.2544 26.6486C29.7166 26.4746 29.1685 26.3298 28.6137 26.2128C28.4989 26.4334 28.4228 26.6638 28.3906 26.9014C28.8703 27.0002 29.3449 27.1204 29.8119 27.2638C29.5096 27.7127 29.2389 28.1804 29.0005 28.664C29.1596 28.8425 29.346 29.0113 29.5567 29.1687C29.8299 28.5876 30.1523 28.0298 30.522 27.5009C32.3242 28.1507 33.9642 29.1192 35.3794 30.3338C35.6852 30.289 35.981 30.2296 36.2646 30.1571C34.7456 28.7607 32.9557 27.6452 30.9735 26.8999C31.4505 26.3043 31.9865 25.7578 32.573 25.2691C33.8364 25.6939 35.1574 25.9094 36.5034 25.9094L36.5404 25.9094H36.5612C37.6022 25.9094 38.6162 26.1402 39.5349 26.5665C39.4198 26.2028 39.2013 25.8602 38.8977 25.5493C38.1502 25.3137 37.3627 25.1894 36.5607 25.1894Z",
    fill: "url(#paint14_linear_170_6962)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7965 29.4447C42.7788 29.3921 42.7607 29.3398 42.7422 29.2877C42.7396 29.2805 42.737 29.2733 42.7344 29.2661C42.7179 29.2201 42.7011 29.1743 42.6839 29.1286C42.68 29.1183 42.6761 29.1081 42.6722 29.0979C42.6559 29.0551 42.6393 29.0124 42.6224 28.9699C42.6178 28.9585 42.6132 28.9471 42.6087 28.9356C42.592 28.8942 42.575 28.853 42.5578 28.8119C42.5529 28.8002 42.5479 28.7884 42.543 28.7768C42.5255 28.7357 42.5078 28.6947 42.4897 28.6538C42.4848 28.6428 42.48 28.6317 42.475 28.6207C42.4562 28.5784 42.437 28.5364 42.4175 28.4945C42.4132 28.4853 42.409 28.476 42.4047 28.4669C42.3835 28.4216 42.3618 28.3765 42.3399 28.3316C42.3372 28.3261 42.3347 28.3206 42.332 28.3151C42.2307 28.1089 42.1221 27.9071 42.0064 27.7098C42.0058 27.709 42.0053 27.708 42.0047 27.7072C41.9771 27.6601 41.949 27.6133 41.9205 27.5667C41.9163 27.5597 41.9119 27.5527 41.9075 27.5458C41.8826 27.5053 41.8575 27.4651 41.8321 27.425C41.8259 27.4152 41.8195 27.4054 41.8132 27.3957C41.7894 27.3585 41.7654 27.3216 41.741 27.2848C41.7336 27.2735 41.726 27.2622 41.7185 27.251C41.6951 27.216 41.6714 27.1811 41.6476 27.1464C41.6392 27.1342 41.6307 27.1219 41.6222 27.1097C41.5988 27.0761 41.5752 27.0426 41.5513 27.0093C41.546 27.0019 41.5407 26.9945 41.5354 26.9871C40.7104 26.2994 39.7465 25.79 38.7109 25.4922C38.795 25.7622 38.8674 26.0372 38.9267 26.3172C40.2354 26.782 41.3935 27.6268 42.2246 28.7643L42.7493 29.4825L42.7973 29.4474C42.7971 29.4464 42.7968 29.4456 42.7965 29.4447Z",
    fill: "url(#paint15_linear_170_6962)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9978 48.8578C33.4297 48.8578 32.9487 48.4202 32.9042 47.8443C32.625 44.2307 30.5721 40.9955 27.4128 39.1903C26.8863 38.8894 26.7034 38.2187 27.0042 37.6922C27.305 37.1656 27.9758 36.9826 28.5023 37.2836C32.2943 39.4503 34.7584 43.335 35.0937 47.6752C35.1403 48.2798 34.6881 48.8078 34.0835 48.8545C34.0548 48.8568 34.0261 48.8578 33.9978 48.8578Z",
    fill: "url(#paint16_linear_170_6962)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6551 48.8578C29.0872 48.8578 28.6061 48.4202 28.5615 47.8445C28.2818 44.23 26.2286 40.9948 23.0693 39.1904C22.5427 38.8897 22.3596 38.219 22.6604 37.6923C22.9611 37.1657 23.6318 36.9826 24.1584 37.2834C27.9505 39.4493 30.415 43.334 30.751 47.675C30.7978 48.2796 30.3456 48.8078 29.741 48.8545C29.7122 48.8568 29.6835 48.8578 29.6551 48.8578Z",
    fill: "url(#paint17_linear_170_6962)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3493 48.8578C37.7813 48.8578 37.3003 48.4202 37.2557 47.8445C36.976 44.2304 34.9232 40.9952 31.7644 39.1903C31.2378 38.8894 31.0549 38.2187 31.3558 37.6922C31.6567 37.1656 32.3273 36.9826 32.8539 37.2836C36.6452 39.45 39.1093 43.3347 39.4452 47.6751C39.492 48.2797 39.0398 48.8078 38.4352 48.8545C38.4064 48.8567 38.3777 48.8578 38.3493 48.8578Z",
    fill: "url(#paint18_linear_170_6962)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0055 48.8578C33.9771 48.8578 33.9486 48.8567 33.9198 48.8545C33.3151 48.8078 32.8629 48.2797 32.9096 47.6751C33.2449 43.335 35.7089 39.4503 39.5009 37.2835C40.0274 36.9826 40.6981 37.1656 40.999 37.6921C41.2998 38.2187 41.1169 38.8894 40.5904 39.1902C37.4311 40.9955 35.3783 44.2306 35.099 47.8443C35.0546 48.4202 34.5736 48.8578 34.0055 48.8578Z",
    fill: "url(#paint19_linear_170_6962)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3493 48.8578C38.3208 48.8578 38.2922 48.8567 38.2633 48.8545C37.6587 48.8077 37.2065 48.2796 37.2533 47.675C37.5893 43.334 40.0538 39.4493 43.8459 37.2834C44.3726 36.9827 45.0432 37.1657 45.344 37.6923C45.6447 38.2189 45.4616 38.8896 44.9351 39.1904C41.7757 40.9948 39.7226 44.23 39.4428 47.8445C39.3983 48.4202 38.9172 48.8578 38.3493 48.8578Z",
    fill: "url(#paint20_linear_170_6962)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.654 48.8578C29.6255 48.8578 29.5969 48.8567 29.568 48.8545C28.9634 48.8077 28.5112 48.2796 28.558 47.675C28.894 43.3346 31.3579 39.4499 35.1493 37.2835C35.6758 36.9826 36.3466 37.1656 36.6474 37.6921C36.9483 38.2187 36.7653 38.8894 36.2388 39.1902C33.08 40.9952 31.0273 44.2304 30.7475 47.8444C30.703 48.4202 30.2219 48.8578 29.654 48.8578Z",
    fill: "url(#paint21_linear_170_6962)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3399 39.5425H23.6658C22.9658 39.5425 22.3984 38.9751 22.3984 38.2751C22.3984 37.5752 22.9658 37.0078 23.6658 37.0078H44.34C45.0399 37.0078 45.6073 37.5752 45.6073 38.2751C45.6072 38.9751 45.0398 39.5425 44.3399 39.5425Z",
    fill: "url(#paint22_linear_170_6962)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_170_6962",
    x1: 32.0474,
    y1: 23.4013,
    x2: 42.4663,
    y2: 49.7603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0DDFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_170_6962",
    x1: 47.18,
    y1: 41.518,
    x2: 9.47644,
    y2: 3.81452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0DDFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_170_6962",
    x1: 32.2792,
    y1: 23.9849,
    x2: 41.4706,
    y2: 47.2384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F92814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_170_6962",
    x1: 21.3273,
    y1: 28.3429,
    x2: 18.8167,
    y2: 28.3429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F92814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_170_6962",
    x1: 34.0018,
    y1: 20.4997,
    x2: 34.0018,
    y2: 17.8459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F92814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_170_6962",
    x1: 35.9647,
    y1: 29.7218,
    x2: 42.9456,
    y2: 2.03901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F92814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_170_6962",
    x1: 47.4392,
    y1: 38.8181,
    x2: 39.9934,
    y2: 32.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F92814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_170_6962",
    x1: 32.5318,
    y1: 24.6244,
    x2: 40.3723,
    y2: 44.4601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0DDFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_170_6962",
    x1: 48.8912,
    y1: 38.8333,
    x2: 35.8402,
    y2: 27.2045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DDFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#C8B7E0",
    stopOpacity: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#A595C8",
    stopOpacity: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8F81B8",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_170_6962",
    x1: 24.7266,
    y1: 32.3955,
    x2: 43.2754,
    y2: 32.3955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F92814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_170_6962",
    x1: 35.0318,
    y1: 33.4322,
    x2: 25.6243,
    y2: 24.0247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_170_6962",
    x1: 34.3215,
    y1: 35.9503,
    x2: 47.0696,
    y2: 12.2406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F92814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_170_6962",
    x1: 34.6159,
    y1: 29.7598,
    x2: 32.9295,
    y2: 22.6163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45227",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDA45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_170_6962",
    x1: 29.7146,
    y1: 27.8399,
    x2: 22.8362,
    y2: 20.7375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC3D2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5577,
    stopColor: "#D4D9E4",
    stopOpacity: 0.558
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EDF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_170_6962",
    x1: 34.0746,
    y1: 27.8129,
    x2: 33.2748,
    y2: 20.1027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC3D2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5577,
    stopColor: "#D4D9E4",
    stopOpacity: 0.558
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EDF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_170_6962",
    x1: 40.4381,
    y1: 29.0216,
    x2: 41.2298,
    y2: 25.1345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555A66",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_170_6962",
    x1: 26.8594,
    y1: 42.9983,
    x2: 35.097,
    y2: 42.9983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A98F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_170_6962",
    x1: 22.5157,
    y1: 42.9983,
    x2: 30.7544,
    y2: 42.9983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A98F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_170_6962",
    x1: 31.211,
    y1: 42.9982,
    x2: 39.4486,
    y2: 42.9982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A98F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_170_6962",
    x1: 41.1438,
    y1: 42.9982,
    x2: 32.9062,
    y2: 42.9982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A98F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_170_6962",
    x1: 45.4887,
    y1: 42.9982,
    x2: 37.25,
    y2: 42.9982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A98F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_170_6962",
    x1: 36.7923,
    y1: 42.9982,
    x2: 28.5547,
    y2: 42.9982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A98F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_170_6962",
    x1: 34.0028,
    y1: 37.196,
    x2: 34.0028,
    y2: 39.6718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_170_6962"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(18 17)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCt6);
export default __webpack_public_path__ + "static/media/ct6.bb7959fdb4dd284b6990b2f6ae25c316.svg";
export { ForwardRef as ReactComponent };